import { DatapointExhibitionTypeState } from '../../../../../reducers';
import { GetFamilyClusterModalPaginationState } from '../../../../../reducers/getFamilyClusterModal/pagination';
import { GetFamilyClusterModalPaginationStateSortState } from '../../../../../reducers/getFamilyClusterModal/sort';
import { camelToSnakeCase } from '../../utils';
import { GET_ITEMS_STORE_FAMILY_CLUSTER_MODAL_PARAMS } from './types';

namespace GetStoreFamilyClusterModalDatapoints {
  export type Params = {
    sort: GetFamilyClusterModalPaginationStateSortState;
    pagination: GetFamilyClusterModalPaginationState;
    clusterId: string;
    productId: string;
    storeId: string;
    productFamilyId: string;
    datapointExhibitionType: DatapointExhibitionTypeState['datapointExhibitionType'];
  };
  export type Return = GET_ITEMS_STORE_FAMILY_CLUSTER_MODAL_PARAMS;
}

export const GET_STORE_FAMILY_CLUSTER_DATAPOINTS_MODEL = (params: GetStoreFamilyClusterModalDatapoints.Params): GetStoreFamilyClusterModalDatapoints.Return => {
  const { sort, pagination, clusterId, productId, storeId, productFamilyId, datapointExhibitionType } = params;

  return {
    sort: `${camelToSnakeCase(sort.type)},${sort.orderBy}`,
    page: pagination.activePage,
    size: pagination.displayLength,
    clusterId,
    productId,
    storeId,
    productFamilyId,
    datapointExhibitionType,
  };
};
